import { ShieldCheck, Wrench, Gauge, Eye, HeartHandshake, Users } from "lucide-react";

const pillars = [
  { icon: Gauge, text: "تشخيص سريع ودقيق" },
  { icon: ShieldCheck, text: "أمانة في تحديد العطل" },
  { icon: Eye, text: "اهتمام بالتفاصيل" },
  { icon: HeartHandshake, text: "تعامل محترم" },
  { icon: Wrench, text: "خبرة عملية مثبتة" },
  { icon: Users, text: "رضا العملاء أولويتنا" },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-6 reveal">
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-cyan-400 font-semibold mb-4">
              <span className="w-8 h-px bg-cyan-400" />
              من نحن
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
              ورشة متخصصة بسمعة حقيقية في الرياض
            </h2>
            <p className="mt-5 text-lg text-slate-300 leading-relaxed">
              مؤسسة <span className="text-white font-semibold">ماجد صالح المخلفي لصيانة السيارات</span>{" "}
              — يقودها الفني المتخصص{" "}
              <span className="text-cyan-300 font-semibold">الكهربائي أسعد السوري</span> —
              ورشة متخصصة بالكامل في أعطال{" "}
              <span className="text-white font-semibold">المكيفات وكهرباء السيارات</span>.
              نشتغل بضمير، ونوضّح العطل قبل الإصلاح، ونختار القطعة المناسبة من
              غير مبالغة.
            </p>
            <p className="mt-4 text-base text-slate-400 leading-relaxed">
              خبرتنا العملية مبنية على آلاف السيارات اللي مرّت على الورشة، ورضا
              عملائنا هو أكبر دليل على جودة الشغل — <span className="text-white font-semibold tabular-nums">+474</span> مراجعة
              بتقييم <span className="text-white font-semibold tabular-nums">4.7/5</span> ما تجي من فراغ.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-3">
              {pillars.map((p, i) => {
                const Icon = p.icon;
                return (
                  <div
                    key={i}
                    className="flex items-center gap-3 p-3.5 rounded-xl border border-slate-800 bg-slate-900/40"
                  >
                    <div className="w-9 h-9 rounded-lg bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center flex-shrink-0">
                      <Icon className="w-4.5 h-4.5 text-cyan-400" />
                    </div>
                    <span className="text-sm text-slate-200 font-medium">
                      {p.text}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-6 reveal">
            <div className="relative">
              <div className="absolute -inset-1 bg-gradient-to-br from-cyan-500/30 to-transparent rounded-3xl blur-2xl" />
              <div className="relative grid grid-cols-2 gap-4">
                <img
                  src="https://images.pexels.com/photos/10985560/pexels-photo-10985560.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                  alt="مقبض تكييف سيارة - ضبط التبريد"
                  className="rounded-2xl object-cover h-56 lg:h-72 w-full border border-slate-800"
                  loading="lazy"
                />
                <img
                  src="https://images.unsplash.com/photo-1727893380169-4dda123e19f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxjYXIlMjBtZWNoYW5pYyUyMGRpYWdub3N0aWMlMjB0b29sfGVufDB8fHx8MTc3Njc0OTYxMHww&ixlib=rb-4.1.0&q=85"
                  alt="جهاز فحص وتشخيص أعطال السيارات"
                  className="rounded-2xl object-cover h-56 lg:h-72 w-full border border-slate-800 mt-6"
                  loading="lazy"
                />
                <div className="col-span-2 rounded-2xl border border-slate-800 bg-slate-900/70 p-5 lg:p-6 flex items-center justify-between">
                  <div>
                    <div className="text-xs text-slate-400">تخصص دقيق</div>
                    <div className="text-lg lg:text-xl font-bold text-white mt-0.5">
                      مكيفات + كهرباء فقط — لا شيء عام
                    </div>
                  </div>
                  <div className="text-cyan-400 font-bold tabular-nums text-2xl">
                    +10
                    <span className="text-sm text-slate-400 font-normal mr-1">
                      سنوات خبرة
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
